import CmcInvestNavySvg from '../assets/logo/cmcinvest/navy.svg';
import CmcInvestWhiteSvg from '../assets/logo/cmcinvest/white.svg';
import { createPaletteColourVariations, createTheme } from './theme';
import { ITheme, IThemeColourPalette } from './interfaces';

export const wireframeLightThemePalette: IThemeColourPalette = {
  primary: {
    first: '#091731', // navy25
    second: '#00C5E8', // ocean100
    text: '#091731' // navy25
  },
  secondary: {
    first: '#325FFF', // sky100
    second: '#1AB99F', // mint100
    third: '#FF9090' // rose100
  },
  neutral: {
    black: '#000000', // noir100
    gray: '#ECEFF0', // cloud100
    white: '#fff'
  },
  alerts: {
    success: '#54FABB',
    pending: '#FFC405',
    alert: '#EE2F53'
  },
  // Temporary, until UX reviews the colors
  trading: {
    up: '#28BE24',
    down: '#FF0101',
    buy: '#18A0FB',
    sell: '#FFC405'
  }
};

export const wireframeDarkThemePalette: IThemeColourPalette = JSON.parse(JSON.stringify(wireframeLightThemePalette));

wireframeDarkThemePalette.primary.first = '#cdd0d5';
wireframeDarkThemePalette.primary.text = '#cdd0d5';
wireframeDarkThemePalette.neutral.black = '#fff';
wireframeDarkThemePalette.neutral.white = '#000';

export const themeBaseLight: ITheme = createTheme('wireframe.light', wireframeLightThemePalette, { normal: CmcInvestNavySvg, inverted: CmcInvestWhiteSvg });
export const themeBaseDark: ITheme = createTheme('wireframe.dark', wireframeDarkThemePalette, { normal: CmcInvestWhiteSvg, inverted: CmcInvestNavySvg });

// for storybook mdx
export const lightPalette = createPaletteColourVariations(wireframeLightThemePalette, wireframeLightThemePalette.neutral.white);
export const darkPalette = createPaletteColourVariations(wireframeDarkThemePalette, wireframeDarkThemePalette.neutral.white);
